export default __webpack_public_path__ + "static/media/about.844c3410.pdf";